/**
 * 密码加密工具
 * 使用 AES 加密，与后端 AESUtil 兼容
 * 注意：需要安装 crypto-js: npm install crypto-js
 * 如果未安装 crypto-js，将使用简单的 Base64 编码
 */

let CryptoJS = null
try {
  // 尝试导入 crypto-js（如果已安装）
  CryptoJS = require('crypto-js')
} catch (e) {
  console.warn('crypto-js 未安装，将使用简单的 Base64 编码。建议安装: npm install crypto-js')
}

/**
 * AES 密钥（与后端 AESUtil.ASSETS_DEV_PWD_FIELD 保持一致）
 */
const AES_KEY = '2nHtbGAYxq3wgZZdcFtye5LKYSuAmWVz'

/**
 * 使用 AES 加密密码（如果 crypto-js 可用）
 * 否则使用简单的 Base64 编码
 * @param {String} password - 要加密的密码
 * @returns {String} 加密后的字符串
 */
export function encryptPassword(password) {
  try {
    if (!password) {
      return password
    }
    
    // 如果 crypto-js 可用，使用 AES 加密
    if (CryptoJS) {
      // 使用 AES/ECB/PKCS5Padding 加密（与后端 AESUtil 兼容）
      const key = CryptoJS.enc.Utf8.parse(AES_KEY)
      const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(password),
        key,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      )
      
      // 转换为 Base64 字符串
      let base64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64)
      
      // 处理特殊字符（与后端保持一致）
      base64 = base64.replace(/\//g, '~SLASH~').replace(/\+/g, '~SUB~')
      
      return base64
    } else {
      // 如果 crypto-js 不可用，使用简单的 Base64 编码
      // 注意：这只是基础编码，不是真正的加密
      let encoded = btoa(unescape(encodeURIComponent(password)))
      // 简单的字符替换
      encoded = encoded.split('').reverse().join('')
      encoded = encoded.replace(/=/g, 'EQ').replace(/\//g, 'SL').replace(/\+/g, 'PL')
      return encoded
    }
  } catch (error) {
    console.error('密码加密错误:', error)
    // 如果加密失败，返回原密码（不应该发生）
    return password
  }
}

